import React, { useState, useEffect } from 'react';
import '../styles/ProjectForm.css';

const ProjectForm = ({ initialData, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    name: '',
    location: '',
    start_date: '',
    end_date: '',
    budget: '',
    client_info: '',
    status: 'planning',
  });
  
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (initialData) {
      setFormData({
        ...initialData,
        start_date: initialData.start_date 
          ? new Date(initialData.start_date).toISOString().split('T')[0] 
          : '',
        end_date: initialData.end_date 
          ? new Date(initialData.end_date).toISOString().split('T')[0] 
          : '',
      });
    }
  }, [initialData]);

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.name.trim()) {
      newErrors.name = 'Proje adı gereklidir';
    }
    
    if (formData.budget && isNaN(parseFloat(formData.budget))) {
      newErrors.budget = 'Bütçe geçerli bir sayı olmalıdır';
    }
    
    if (formData.start_date && formData.end_date) {
      const startDate = new Date(formData.start_date);
      const endDate = new Date(formData.end_date);
      if (startDate > endDate) {
        newErrors.end_date = 'Bitiş tarihi başlangıç tarihinden sonra olmalıdır';
      }
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    // Clear error for this field when user starts typing
    if (errors[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: '',
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }
    
    try {
      setLoading(true);
      // Pass only the form data, not the id
      await onSubmit(formData);
    } catch (error) {
      console.error('Form submission error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="project-form" onSubmit={handleSubmit}>
      <div className="form-header">
        <h3>{initialData ? 'Projeyi Düzenle' : 'Yeni Proje Oluştur'}</h3>
        <button 
          type="button" 
          className="btn-close" 
          onClick={onCancel}
          aria-label="Close form"
        >
          ✕
        </button>
      </div>

      <div className="form-body">
        {/* Project Name */}
        <div className="form-group">
          <label htmlFor="name">Proje Adı *</label>
          <input 
            type="text" 
            id="name"
            name="name" 
            value={formData.name} 
            onChange={handleChange}
            placeholder="Proje adını girin"
            className={errors.name ? 'error' : ''}
          />
          {errors.name && <span className="error-text">{errors.name}</span>}
        </div>

        {/* Location */}
        <div className="form-group">
          <label htmlFor="location">Konum</label>
          <input 
            type="text" 
            id="location"
            name="location" 
            value={formData.location} 
            onChange={handleChange}
            placeholder="Proje konumunu girin"
          />
        </div>

        {/* Start Date */}
        <div className="form-group">
          <label htmlFor="start_date">Başlangıç Tarihi</label>
          <input 
            type="date" 
            id="start_date"
            name="start_date" 
            value={formData.start_date} 
            onChange={handleChange}
          />
        </div>

        {/* End Date */}
        <div className="form-group">
          <label htmlFor="end_date">Bitiş Tarihi</label>
          <input 
            type="date" 
            id="end_date"
            name="end_date" 
            value={formData.end_date} 
            onChange={handleChange}
            className={errors.end_date ? 'error' : ''}
          />
          {errors.end_date && <span className="error-text">{errors.end_date}</span>}
        </div>

        {/* Budget */}
        <div className="form-group">
          <label htmlFor="budget">Bütçe (₺)</label>
          <input 
            type="number" 
            id="budget"
            name="budget" 
            value={formData.budget} 
            onChange={handleChange}
            placeholder="0"
            step="0.01"
            className={errors.budget ? 'error' : ''}
          />
          {errors.budget && <span className="error-text">{errors.budget}</span>}
        </div>

        {/* Status */}
        <div className="form-group">
          <label htmlFor="status">Durum</label>
          <select 
            id="status"
            name="status" 
            value={formData.status} 
            onChange={handleChange}
          >
            <option value="planning">Planlama</option>
            <option value="in_progress">Devam Ediyor</option>
            <option value="completed">Tamamlandı</option>
            <option value="on_hold">Askıda</option>
          </select>
        </div>

        {/* Client Info */}
        <div className="form-group">
          <label htmlFor="client_info">Müşteri Bilgileri</label>
          <textarea 
            id="client_info"
            name="client_info" 
            value={formData.client_info} 
            onChange={handleChange}
            placeholder="Müşteri bilgilerini girin..."
            rows="4"
          ></textarea>
        </div>
      </div>

      <div className="form-footer">
        <button 
          type="submit" 
          className="btn-submit"
          disabled={loading}
        >
          {loading ? 'Kaydediliyor...' : (initialData ? 'Güncelle' : 'Oluştur')}
        </button>
        <button 
          type="button" 
          className="btn-cancel"
          onClick={onCancel}
          disabled={loading}
        >
          İptal
        </button>
      </div>
    </form>
  );
};

export default ProjectForm;
